<template>
    <div class="block-pink flex flex-row items-center rounded border border-reg_orange_l bg-reg_pink py-reg_8 px-reg_12">
        <svg-icon name="icon__alert-circle" class="icon__alert-circle w-reg_40 h-reg_24 fill-reg_orange" />
        <p class="pl-reg_10 text-xs_reg text-reg_black">{{text}}</p>
    </div>
</template>

<script>
import SvgIcon from "@/components/ui/svgicon";

export default {
  name: "info",
  components: {SvgIcon},
  props: {
      text : {
        type : String,
        require : false
      }
  },
}
</script>

<style scoped>

</style>